import { US_STATE_SHORTHAND_TO_NAME } from "./US_STATE_SHORTHAND_TO_NAME";

export const US_STATE_SHORTHAND = Object.keys(US_STATE_SHORTHAND_TO_NAME);
